import React from 'react';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Form } from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import { PasswordStrengthField, SubmitButton } from '../../../../shared/components/Form';
import Header from '../components/Header';
import { ERROR_TITLES } from '../constants';
import { useResetPasswordForm } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const ResetPassword = () => {
  const { error, form, handleSubmit: onSubmit, isSubmitting } = useResetPasswordForm();

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Reset Password" />

        <Form {...form}>
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
            <PasswordStrengthField control={form.control} />
            <SubmitButton isLoading={isSubmitting}>Reset Password</SubmitButton>

            {error && (
              <Alert
                description={error.message}
                icon={alertIcon}
                title={ERROR_TITLES.password.update}
                variant="destructive"
              />
            )}
          </form>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
